// === src/components/Footer/Footer.js ===
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      © 2025 Stronghold Software. All Rights Reserved.
    </footer>
  );
}
